const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

class LadyMoleculeCinematicHero extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.track = this.querySelector('[data-lm-hero-track]');
    this.slides = Array.from(this.querySelectorAll('[data-lm-hero-slide]'));
    this.currentCounter = this.querySelector('[data-lm-hero-current]');
    this.totalCounter = this.querySelector('[data-lm-hero-total]');
    this.progressFill = this.querySelector('[data-lm-hero-progress-fill]');
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.totalCounter) {
      this.totalCounter.textContent = String(this.slides.length || 1).padStart(2, '0');
    }

    this.requestTick = this.requestTick.bind(this);
    this.onResize = this.onResize.bind(this);

    window.addEventListener('scroll', this.requestTick, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });

    requestAnimationFrame(() => {
      this.classList.add('is-ready');
      this.update();
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.requestTick);
    window.removeEventListener('resize', this.onResize);

    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
  }

  onResize() {
    this.update();
  }

  requestTick() {
    if (this.rafId) return;

    this.rafId = requestAnimationFrame(() => {
      this.rafId = null;
      this.update();
    });
  }

  update() {
    if (!this.track) return;

    const rect = this.track.getBoundingClientRect();
    const totalScrollable = Math.max(this.track.offsetHeight - window.innerHeight, 1);
    const progress = clamp(-rect.top / totalScrollable, 0, 1);
    const storyProgress = clamp((progress - 0.12) / 0.78, 0, 1);
    const introFade = clamp(progress / 0.22, 0, 1);
    const activeIndex = this.getActiveIndex(storyProgress);

    this.style.setProperty('--lm-hero-progress', progress.toFixed(4));
    this.style.setProperty('--lm-intro-fade', introFade.toFixed(4));
    this.style.setProperty('--lm-story-opacity', storyProgress.toFixed(4));
    this.style.setProperty('--lm-story-shift', `${(1 - storyProgress) * 28}px`);

    if (this.progressFill) {
      this.progressFill.style.transform = `scaleX(${Math.max(storyProgress, 0.04)})`;
    }

    if (this.currentCounter) {
      this.currentCounter.textContent = String(activeIndex + 1).padStart(2, '0');
    }

    this.slides.forEach((slide, index) => {
      slide.classList.toggle('is-active', index === activeIndex);

      if (this.prefersReducedMotion) {
        slide.style.transitionDuration = '0ms';
      }
    });
  }

  getActiveIndex(storyProgress) {
    if (this.slides.length <= 1) return 0;

    return Math.min(this.slides.length - 1, Math.floor(storyProgress * this.slides.length));
  }
}

if (!customElements.get('lady-molecule-cinematic-hero')) {
  customElements.define('lady-molecule-cinematic-hero', LadyMoleculeCinematicHero);
}
